import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";

export default function WhatsAppChannelCard({
  title = "Join IT Jobs & Referrals Channel",
  subtitle = "Freshers & Experienced Welcome",
  features = [
    "Daily job & internship updates",
    "Off-campus drives & walk-ins",
    "Exclusive referral support",
  ],
  description = "Stay updated. Share. Grow together 💼🌐",
  channelLink = "https://whatsapp.com/channel/0029Vb624Xx4inoky9MAGB2n",
}) {
  return (
    <motion.div
      className="relative p-6 bg-white border border-gray-200 rounded-xl shadow-md hover:shadow-lg transition-shadow group w-full"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {/* Header Row with Title & Join Button */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 rounded-full bg-green-50">
            <FaWhatsapp className="text-green-600 text-2xl" />
          </div>
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900">
            <FallingText text={title} />
          </h3>
        </div>

        {/* Join Button */}
        <a
          href={channelLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-4 py-2 w-full sm:w-auto bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition"
        >
          <FaWhatsapp className="mr-2" /> Join
        </a>
      </div>

      {/* Subtitle */}
      <p className="text-green-700 font-medium mb-3 text-sm">{subtitle}</p>

      {/* Features List */}
      <div className="flex flex-wrap gap-2 mb-4">
        {features.map((feat, i) => (
          <span
            key={i}
            className="px-2 py-1 bg-green-50 text-green-700 rounded-full text-xs sm:text-sm"
          >
            {feat}
          </span>
        ))}
      </div>

      {/* Description */}
      <p className="text-gray-700 text-sm">{description}</p>
    </motion.div>
  );
}

export function FallingText({ text }) {
  const letters = text.split("");

  return (
    <div className="inline-flex overflow-hidden">
      {letters.map((char, i) => (
        <motion.span
          key={i}
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{
            duration: 0.5,
            delay: i * 0.05,
            ease: "easeOut",
          }}
          className="inline-block"
        >
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
    </div>
  );
}
